const PostAction = Object.freeze({
	Download: 1,
	CreatePowerpointSlide: 2,
	AddToInsightBrief: 3,
	ShareViaEmailBrief: 4,
	ShareViaPrivateLink: 5,
	ShareViaPublicLink: 6,
	PushToSlack: 7,
	PushToMicrosoftTeams: 8,
});

export default PostAction;
